import $ from 'jquery'
import { isSP } from './checkScreen'

const jsSmoothScroll = () => {
  const $jsScrolls = $('.js-scroll')
  const $winWidth = $(window).width()
  const $winHeight = $(window).height()

  $jsScrolls.each((index, el) => {
    $(el).on('click', () => {
      const speed = 400
      const href = $(el).attr('href')
      const $target = $(href === '#' || href === '' ? 'html' : href)
      const position = $target.offset().top
      let headerHeight = 0

      if (isSP()) {
        headerHeight = $('#header').height()
      }

      if (href === '#') {
        // リンク#のときはページの先頭へ
        $('body,html').animate({ scrollTop: 0 }, speed, 'swing')
      } else {
        // それ以外は指定idへ
        $('body, html').animate({ scrollTop: position - headerHeight }, speed, 'swing')
      }
      return false
    })
  })
}

const initSmoothScroll = () => {
  jsSmoothScroll()

  $(window).on('resize', () => {
    jsSmoothScroll()
  })
}

export default initSmoothScroll
